import React from "react";
import { withDomains } from "../../lib/domain";
import Text from "antd/lib/typography/Text";
import { useHistory } from "react-router-dom";

const ForgotPasswordEmailSent = () => {
  const history = useHistory();
  return (
    <div>
      <div className="container">
        <div className="header-menu">
          <img src="images/logo.svg" className="header-menu-item" />
          <span className="header-menu-item">
            Remember your Password?
            <a
              onClick={() => {
                history.push("/");
              }}
            >
              &nbsp;Log In
            </a>
          </span>
        </div>
      </div>
      <div
        className="main-container"
        style={{
          marginTop: "100px",
        }}
      >
        <div
          className="container"
          style={{
            maxWidth: "370px",
            display: "flex",
            gap: "12px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              minWidth: "100%",
            }}
          >
            <img src="images/email_icon.svg" alt="email" />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "8px",
            }}
          >
            <Text
              style={{
                fontSize: "24px",
                fontWeight: "500",
                color: "#10223B",
                lineHeight: "29.05px",
              }}
            >
              Email Sent
            </Text>
            <Text
              style={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#636972",
                lineHeight: "21.76px",
              }}
            >
              Check your email and open the link we sent to reset your password.{" "}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withDomains(ForgotPasswordEmailSent, "password");
